module.exports = __webpack_public_path__ + "static/media/cn.2c193ab3.svg";